import moment from 'moment';
import { useState } from 'react';
import { useBookingContext } from '../context';
import Header from './Header';
import { isMobile } from 'react-device-detect';

const DesctopWeekCalendar = ({ weekDays, setSelectedDate, selectedDate }) => {
  const dayStyle = (itemDate) => {
    if (itemDate.isBefore(moment(), 'day')) return 'passed-days';
    if (itemDate.isSame(selectedDate, 'day')) return 'active-day';
  };
  return (
    <div className="week u-color-white m-4">
      <div className="swiper swiper-initialized swiper-horizontal swiper-backface-hidden">
        <div className="swiper-wrapper">
          <div className="swiper-slide week__list swiper-slide-active">
            {weekDays.map((day, idx) => (
              <li
                className={`week__item ${dayStyle(day.date)}`}
                key={day + idx}
                onClick={() => dayStyle(day.date) !== 'passed-days' && setSelectedDate(day.date)}>
                {day.name}, {day.dateString}
              </li>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

const MobileWeekCalendar = ({ weekDays, setSelectedDate, selectedDate }) => {
  return (
    <div className="week u-color-white mx-4">
      <div className="swiper swiper-initialized swiper-horizontal swiper-backface-hidden">
        <div className="swiper-wrapper">
          <div className="swiper-slide week__list swiper-slide-active">
            {weekDays.map((day, idx) => (
              <div
                className={`flex flex-col text-[16px] font-semibold w-full justify-center items-center ${
                  day.date.isBefore(moment(), 'day') ? 'opacity-40' : ''
                }`}
                key={day + idx}>
                {day.name}
                <div
                  className={`border-2  rounded-full w-10 h-10 flex justify-center items-center my-2 ${
                    day.date.isSame(selectedDate, 'day')
                      ? 'bg-white border-white text-black'
                      : 'border-zinc-700'
                  }`}
                  onClick={() => setSelectedDate(day.date)}>
                  {moment(day.date).format('DD')}
                </div>
                {moment(day.date).format('MMM')}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default () => {
  const { setSelectedDate, selectedDate } = useBookingContext();
  const currentWeek = moment().week();
  const [visibleWeek, setVisibleWeek] = useState(currentWeek);

  const weekDays = moment
    .weekdaysShort()
    .map((_, idx, arr) => (arr[idx + 1] ? arr[idx + 1].toUpperCase() : arr[0].toUpperCase()))
    .map((day) => {
      const itemDay = moment().day(day).week(visibleWeek);
      return {
        name: day,
        dateString: itemDay.format('DD MMM'),
        date: itemDay
      };
    });

  return (
    <>
      <Header
        visibleWeek={visibleWeek}
        currentWeek={currentWeek}
        onTodayPress={() => {
          setVisibleWeek(currentWeek);
          setSelectedDate(moment());
        }}
        onLeftArrowClick={() => {
          visibleWeek > currentWeek && setVisibleWeek((w) => w - 1);
        }}
        onRightArrowClick={() => {
          visibleWeek < currentWeek + 5 && setVisibleWeek((w) => w + 1);
        }}
      />
      {isMobile ? (
        <MobileWeekCalendar
          weekDays={weekDays}
          setSelectedDate={setSelectedDate}
          selectedDate={selectedDate}
        />
      ) : (
        <DesctopWeekCalendar
          weekDays={weekDays}
          setSelectedDate={setSelectedDate}
          selectedDate={selectedDate}
        />
      )}
    </>
  );
};
